(function () {
  const SELECTOR = '[data-paid-landing-story]';
  const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initStory(story) {
    if (story.dataset.paidStoryReady === 'true') return;

    let scheduled = false;
    function update() {
      scheduled = false;
      if (window.matchMedia(REDUCED_MOTION).matches) {
        story.style.setProperty('--paid-story-progress', '0');
        return;
      }

      const rect = story.getBoundingClientRect();
      const travel = Math.max(window.innerHeight + rect.height, 1);
      const progress = clamp((window.innerHeight - rect.top) / travel, 0, 1);
      story.style.setProperty('--paid-story-progress', progress.toFixed(4));
    }

    function requestUpdate() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          story.classList.add('is-visible');
          requestUpdate();
        });
      },
      { threshold: 0.18 }
    );

    observer.observe(story);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    story.dataset.paidStoryReady = 'true';
    requestUpdate();
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(initStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
